const PAGE_INSTANCE_ID_BYTES = 8;

const randomHex = (bytes: number) => Array.from(
  crypto.getRandomValues(new Uint8Array(bytes)),
  (byte) => byte.toString(16).padStart(2, '0'),
).join('');

export const PAGE_INSTANCE_ID = randomHex(PAGE_INSTANCE_ID_BYTES);
